import styled from 'styled-components'

export const BowtieAlarmsContainer = styled.div`
    padding: 24px 0;

    @media (min-width: 992px) {
        width: 710px;
        width: 930px;
    }
    @media (min-width: 1600px) {
        width: 1130px;
    }

    .cards-settings {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 24px 0 24px 0;
    }

    .times-daily-reports {
        display: flex;
        width: 100%;
        gap: 8px;
    }

    .select-time {
        width: 50%;
    }

    .no-bowties-assigned {
        display: flex;
        width: 100%;
        height: 200px;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
    }
`

export const AbsoluteLoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    background: var(--gray-300);
`

export const NoInfo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
`

export const AlarmSettings = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
